import { css } from 'styled-components';
import { StyledPlaceHolderItem } from './PlaceHolder.styles';
import { device } from '../breakpoints';
import { GAP, getArticleWidth, NO_OF_ITEMS } from '../ContentItemCarousel/ContentItemCarousel.styles';

export const getDefaultLayout = () => css`
    ${StyledPlaceHolderItem} {
        flex: 0 0 100%;
        display: inline-block;
        margin-right: ${GAP.DEFAULT}px;
        max-width: ${getArticleWidth(GAP.DEFAULT, NO_OF_ITEMS.DEFAULT)};

        @media ${device.GteMedium} {
            margin-right: ${GAP.GTE_MEDIUM}px;
            max-width: ${getArticleWidth(GAP.GTE_MEDIUM, NO_OF_ITEMS.GTE_MEDIUM)};
        }

        @media ${device.GteXLarge} {
            margin-right: ${GAP.GTE_XLARGE}px;
            max-width: ${getArticleWidth(GAP.GTE_XLARGE, NO_OF_ITEMS.GTE_XLARGE)};
        }

        @media ${device.FullScreen} {
            margin-right: ${GAP.FULLSCREEN}px;
            max-width: ${getArticleWidth(GAP.FULLSCREEN, NO_OF_ITEMS.FULLSCREEN)};
        }
    }
`;
